import React from "react";
import { motion } from "framer-motion";
import { ImagePlus, Heart } from "lucide-react";
import { IMAGES } from "../../lib/constants";

export const Family = () => {
  return (
    <section
      id="familia"
      className="relative py-20 md:py-28 bg-gradient-to-b from-bege to-[#ece3d4]"
      data-testid="family-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto"
        >
          <div className="text-xs tracking-[0.35em] uppercase text-gold font-semibold mb-3">
            de geração em geração
          </div>
          <h2 className="font-serif-display text-4xl md:text-5xl text-bordo font-semibold leading-tight" data-testid="family-title">
            A Família por Trás <br />
            <span className="italic">do Sabor</span>
          </h2>
          <div className="gold-ornament mt-6" />
          <p className="mt-6 text-dark/75 text-base md:text-lg leading-relaxed">
            28 anos de dedicação, amor e muito trabalho — essa é a história
            da família que alimenta Sorriso.
          </p>
        </motion.div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {IMAGES.family.map((item, i) => {
            const isFullView = item.caption === "A família toda — parceria e união só no O Padrinho";
            return (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.55, delay: i * 0.08 }}
              className="card-hover flex flex-col"
              data-testid={`family-item-${i}`}
            >
              <div className={`relative rounded-2xl overflow-hidden shadow-lg border-2 border-gold/30 bg-white ${isFullView ? "" : "aspect-[4/5]"}`}>
                {item.src ? (
                  <img
                    src={item.src}
                    alt={item.caption}
                    className={`w-full h-full transition-transform duration-700 hover:scale-105 ${isFullView ? "object-contain" : "object-cover"}`}
                  />
                ) : (
                  <div className="w-full h-full flex flex-col items-center justify-center text-center px-6 bg-gradient-to-br from-bege via-white to-bege aspect-[4/5]">
                    <ImagePlus size={40} className="text-gold mb-3" strokeWidth={1.4} />
                    <p className="text-xs md:text-sm text-bordo/80 font-medium leading-relaxed">
                      Foto em breve
                    </p>
                  </div>
                )}
              </div>
              <figcaption className="mt-4 text-center">
                <Heart size={14} className="inline text-gold mr-1.5 -mt-1" fill="currentColor" strokeWidth={0} />
                <span className="text-sm md:text-base text-bordo italic font-medium">
                  {item.caption}
                </span>
              </figcaption>
            </motion.figure>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Family;
